import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { BLOCKS, INLINES, Document } from '@contentful/rich-text-types';
import { Heading, Paragraph, Subheading } from 'components/src/typography';

type Props = {
  data: Document;
};

const DefaultRichText = ({ data }: Props) => {
  return (
    <>
      {documentToReactComponents(data, {
        renderNode: {
          [BLOCKS.HEADING_6]: (_node, children) => <Subheading>{children}</Subheading>,
          [BLOCKS.HEADING_5]: (_node, children) => <Heading variant="xs">{children}</Heading>,
          [BLOCKS.HEADING_4]: (_node, children) => <Heading variant="small">{children}</Heading>,
          [BLOCKS.HEADING_3]: (_node, children) => <Heading variant="medium">{children}</Heading>,
          [BLOCKS.HEADING_2]: (_node, children) => <Heading variant="large">{children}</Heading>,
          [BLOCKS.HEADING_1]: (_node, children) => <Heading variant="xl">{children}</Heading>,
          [BLOCKS.PARAGRAPH]: (_node, children) => {
            return <Paragraph>{children}</Paragraph>;
          },
          [INLINES.HYPERLINK]: (node, children) => (
            <a href={node.data.uri} className="text-red-100 hover:underline">
              {children}
            </a>
          ),
        },
      })}
    </>
  );
};
export default DefaultRichText;
